import {
  IStoreExchangeAllowedStores,
  IStoreExchangeFilters,
  IStoreExchangeParams,
  IStoreExchangeResponse,
  StoreExchangeExportResult,
} from "src/@types/store-exchange";

import { toQueryParams } from "@/utils/to-query-params";
import { apiSlice } from "./http";

const NO_CONTENT = 204;

async function exportRequestHandler(
  response: Response,
): Promise<StoreExchangeExportResult> {
  if (response.status === NO_CONTENT) {
    return {};
  }
  return response.json().catch(() => response.text());
}

export const storeExchangeApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getStoreExchanges: builder.query<
      IStoreExchangeResponse,
      IStoreExchangeParams
    >({
      query: filters => ({
        url: `/store-exchange?${toQueryParams(filters)}`,
        method: "GET",
      }),
    }),
    getStoreExchangeAllowedStores: builder.query<
      IStoreExchangeAllowedStores,
      void
    >({
      query: () => ({
        url: "/store-exchange/allowed-stores",
        method: "GET",
      }),
    }),
    exportStoreExchangesExcel: builder.mutation<
      StoreExchangeExportResult,
      IStoreExchangeFilters
    >({
      query: filters => ({
        url: `/store-exchange/export?${toQueryParams(filters)}`,
        method: "POST",
        responseHandler: exportRequestHandler,
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetStoreExchangesQuery,
  useGetStoreExchangeAllowedStoresQuery,
  useExportStoreExchangesExcelMutation,
} = storeExchangeApi;
